import { SVGProps } from 'react';
import FacebookLogoSvg from './facebook-logo.svg?react';

export const FacebookLogo = (props: SVGProps<SVGSVGElement>) => {
  return <FacebookLogoSvg {...props} />;
};
